module.exports = __webpack_public_path__ + "static/media/awards-2.c8ec78e5.png";